import React from 'react';
import { ECarriersList } from 'types/Carrier';
import {
	SECTIONS_VISIBILITY_CONFIG,
	SectionsListConfig,
} from 'types/SectionsVisibility';

type Props = {
	children: React.ReactNode;
	sectionName: keyof SectionsListConfig;
	carrier?: { customLayout?: ECarriersList | null };
};

export const useSectionVisible = (
	sectionName: keyof SectionsListConfig,
	carrier?: { customLayout?: ECarriersList | null },
) => {
	if (!carrier) return false;
	// based on the carrier we check the sections inside either the loggedIn or notLoggedIn object
	const config =
		SECTIONS_VISIBILITY_CONFIG[
			carrier.customLayout || ECarriersList.BASIC_CARRIER
		];

	return config && config[sectionName];
};

const SectionVisible = ({ children, sectionName, carrier }: Props) => {
	const isSectionVisible = useSectionVisible(sectionName, carrier);

	if (isSectionVisible) {
		return <>{children}</>;
	}

	return <></>;
};

export default SectionVisible;
